import React from 'react';

import ProgressBar from './ProgressBar';
import { UploadingFile } from './types';

import IconButton from '~/core/atoms/Buttons/IconButton';
import DocumentIcon from '~/core/iconComponents/icons/DocumentIcon';
import TrashIcon from '~/core/iconComponents/icons/TrashIcon';
import WarningIcon from '~/core/iconComponents/icons/WarningIcon';

interface FileRecordProps {
  file: UploadingFile;
  onRemove: (file: File) => void;
}

const ERROR_STATUS = 'error';

const FileRecord: React.FC<FileRecordProps> = ({ file, onRemove }) => (
  <div className="bg-grey-100/70 flex flex-col items-start rounded-sm p-8">
    <div className="flex w-full items-center justify-between gap-4 text-sm">
      <DocumentIcon />
      <span className="flex-1 cursor-default overflow-hidden text-slate-800" title={file.file.name}>
        {file.file.name.length > 30 ? `${file.file.name.slice(0, 30)}...` : file.file.name}
      </span>
      {file.status === ERROR_STATUS && (
        <span className="cursor-default text-red-500" title={file.error ?? undefined}>
          <WarningIcon className="text-yellow-700" />
        </span>
      )}
      <IconButton
        onClick={() => onRemove(file.file)}
        className="flex items-center justify-center rounded-full hover:bg-slate-300"
        size="sm"
        round
      >
        <TrashIcon className="text-slate-700 hover:text-black" />
      </IconButton>
    </div>
    <ProgressBar uploadedFile={file} />
  </div>
);

export default FileRecord;
